import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Users, Plus } from "lucide-react";

export default function Groups() {
  const [groups, setGroups] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", description: "" });
  const navigate = useNavigate();

  const load = async () => { const { data } = await api.get("/groups"); setGroups(data); };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    const { data } = await api.post("/groups", form);
    setOpen(false); setForm({ name: "", description: "" });
    navigate(`/groups/${data.id}`);
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-12" data-testid="groups-page">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="label-eyebrow">Discussion spaces</div>
          <h1 className="mt-2 font-display text-4xl text-[#0A192F]">Groups</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button className="bg-[#002855] hover:bg-[#0A192F] text-white rounded-md" data-testid="create-group-button"><Plus className="w-4 h-4 mr-2" />New group</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle className="font-display text-2xl">Create a group</DialogTitle></DialogHeader>
            <form onSubmit={create} className="space-y-4">
              <div className="space-y-1.5"><Label htmlFor="gn">Name</Label><Input id="gn" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required data-testid="group-name-input" /></div>
              <div className="space-y-1.5"><Label htmlFor="gd">Description</Label><Textarea id="gd" value={form.description} onChange={e => setForm({...form, description: e.target.value})} data-testid="group-desc-input" /></div>
              <Button type="submit" className="bg-[#002855] hover:bg-[#0A192F] text-white" data-testid="group-create-submit">Create group</Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {groups.map(g => (
          <Link to={`/groups/${g.id}`} key={g.id} className="card-flat p-6 hover:-translate-y-0.5 hover:shadow-md transition-all" data-testid={`group-card-${g.id}`}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-md bg-[#002855] text-[#C5A059] flex items-center justify-center"><Users className="w-5 h-5" /></div>
              <div>
                <div className="font-display text-xl text-[#0A192F]">{g.name}</div>
                <div className="text-xs text-slate-500">{g.members_count} members</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-slate-600 leading-relaxed">{g.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
